import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FrontierAction } from '../../store/frontier.action';
import { OfferAction } from '../../store/offer.action';

@Injectable()
export class FrontierSummaryResolver implements Resolve<any> {

    constructor(private store: Store) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        const id = +route.params.id;
        return this.store.dispatch(new FrontierAction.GetOne(id));
    }
}
